import { buildGridItems } from './buildGridItems';

export async function loadGridItems({ dataUrl, countermeasuresUrl }) {
  const [rootRes, cmRes] = await Promise.all([fetch(dataUrl), fetch(countermeasuresUrl)]);
  if (!rootRes.ok) throw new Error(`Failed to fetch ${dataUrl}: ${rootRes.status}`);
  if (!cmRes.ok) throw new Error(`Failed to fetch ${countermeasuresUrl}: ${cmRes.status}`);

  const [root, countermeasures] = await Promise.all([rootRes.json(), cmRes.json()]);
  return buildGridItems({ root, countermeasures });
}
